"use strict";
/**
 * @name TextLink
 *
 * @description
 * A common link component that will render the appropriate styles for a link.  Accepts a routerLink which would be the
 * <Link /> function from a library like react-router.
 *
 * @example
 *  <TextLink
 *    routerLink={ Link }
 *    location="/home"
 *    style={{ color: 'red'}} />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    children: PropTypes.node.isRequired,
    routerLink: PropTypes.func,
    location: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    otherProps: PropTypes.object,
};
var TextLink = function (props) {
    var _a;
    var children = props.children, location = props.location, routerLink = props.routerLink, onClick = props.onClick, className = props.className, mods = props.mods, style = props.style, otherProps = props.otherProps;
    // Define anchorTag to be the passed in router 'Link' or 'a' as default.
    var AnchorTag = routerLink || 'a';
    // Various React Routers use the attribute 'to' as opposed to the html anchors default 'href'
    var linkType = (_a = {}, _a[routerLink ? 'to' : 'href'] = location, _a);
    return (React.createElement(AnchorTag, __assign({ className: (0, helpers_1.getClassName)(className, mods), style: style, onClick: onClick }, linkType, otherProps), children));
};
TextLink.defaultProps = {
    routerLink: null,
    location: '',
    onClick: null,
    className: '',
    mods: null,
    style: {},
    otherProps: {},
};
exports.default = TextLink;
